/*
 * Add future delivery cities here.
 * Keep each pincode as a six-character string, sorted ascending.
 */
const DELIVERY_ZONES = {
  Jalandhar: [
    '144001', '144002', '144003', '144004', '144005', '144006',
    '144007', '144008', '144009', '144010', '144011', '144012',
    '144013', '144020', '144021', '144022', '144023', '144024',
    '144025', '144026', '144027', '144028', '144029', '144030'
  ],

  Kartarpur: [
    '144801'
  ],

  Adampur: [
    '144102', '144103', '144106'
  ],

  Phagwara: [
    '144401', '144402', '144403', '144404', '144405',
    '144406', '144407', '144408', '144411'
  ],

  Kapurthala: [
    '144601', '144602', '144603'
  ],

  Nakodar: [
    '144040', '144041', '144042', '144043', '144044',
    '144045', '144046', '144047', '144048', '144049'
  ]
};

const SERVICEABLE_PINCODES = new Set(
  Object.values(DELIVERY_ZONES).flat()
);

const isServiceable = function (pincode) {
  const normalizedPincode = String(pincode || '').trim();

  return (
    /^\d{6}$/.test(normalizedPincode) &&
    SERVICEABLE_PINCODES.has(normalizedPincode)
  );
};

/* Expose only the validation API to the order-form script. */
window.JBDeliveryZones = {
  DELIVERY_ZONES: DELIVERY_ZONES,
  SERVICEABLE_PINCODES: SERVICEABLE_PINCODES,
  isServiceable: isServiceable
};